import { Injectable } from '@angular/core';
import { CustomBasePageMetaResolver } from '@core/feature';
import {
  BreadcrumbMeta,
  CanonicalPageResolver,
  CanonicalUrlOptions,
  PageBreadcrumbResolver,
  PageDescriptionResolver,
  PageLinkService,
  PageMetaResolver,
  PageRobotsMeta,
  PageRobotsResolver,
  PageTitleResolver,
  PageType,
  PageTypeResolver,
  WindowRef,
} from '@spartacus/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomePageMetaResolver
  extends PageMetaResolver
  implements
    PageTitleResolver,
    PageBreadcrumbResolver,
    PageDescriptionResolver,
    PageRobotsResolver,
    CanonicalPageResolver,
    PageTypeResolver
{
  constructor(
    private basePageMetaResolver: CustomBasePageMetaResolver,
    private winRef: WindowRef,
    private pageLinkService: PageLinkService,
  ) {
    super();
    this.pageType = PageType.CONTENT_PAGE;
    this.pageTemplate = 'LandingPage2Template';
  }

  resolveTitle(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveTitle();
  }

  resolveDescription(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveDescription();
  }

  resolveBreadcrumbs(): Observable<BreadcrumbMeta[] | undefined> {
    return this.basePageMetaResolver.resolveBreadcrumbs();
  }

  resolveRobots(): Observable<PageRobotsMeta[]> {
    const urlGetParams: string | undefined = this.winRef.location.href.split('?')[1];

    if (urlGetParams?.includes('page=')) {
      return of([PageRobotsMeta.NOFOLLOW, PageRobotsMeta.NOINDEX]);
    }

    return this.basePageMetaResolver.resolveRobots();
  }

  resolveCanonicalUrl(options?: CanonicalUrlOptions): Observable<string> {
    return of(this.pageLinkService.getCanonicalUrl(options, this.winRef.location.origin));
  }

  resolveType(): Observable<string> {
    return this.basePageMetaResolver.resolveType();
  }
}
